import { create } from "zustand";
import { apiCall } from "../../../utils/apiCall";
import { API_BASE_URL1, API_BASE_URL3 } from "../../Services/baseApiUrl";

export const AllocatedVehicleStore = create((set, get) => ({
  // Corporations list
  AllocatedVehicles: [],
  isFetchAllocatedVehiclesLoading: false,

  fetchAllocatedVehicles: async () => {
    set({ isFetchAllocatedVehiclesLoading: true });
    try {
      const res = await apiCall({
        url: `${API_BASE_URL3}MasterCreate/GetAllotedVehicleDetails`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        AllocatedVehicles: res,
        isFetchAllocatedVehiclesLoading: false,
      });
    } catch (error) {
      set({ isFetchAllocatedVehiclesLoading: false });
    }
  },

  // Zone + Circles by Corporation
  ZoneCirclesDetails: [],
  isFetchZoneCirclesLoading: false,

  fetchZoneCirclesByCorporation: async (corporationId) => {
    set({ isFetchZoneCirclesLoading: true, ZoneCirclesDetails: [] });
    try {
      const res = await apiCall({
        url: `${API_BASE_URL3}MasterCreate/GetZoneCircleHierarchy?CorporationId=${corporationId}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        ZoneCirclesDetails: res?.zones || [],
        isFetchZoneCirclesLoading: false,
      });
    } catch (error) {
      set({ isFetchZoneCirclesLoading: false });
    }
  },

  // Fetch allocated vehicle details by specific parameters
  isFetchingAllocatedByParams: false,
  allocatedVehiclesByParams: {},

  fetchAllocatedVehiclesByParams: async (corporationId, ownerTypeId, shiftId) => {
    set({ isFetchingAllocatedByParams: true });
    try {
      const res = await apiCall({
        url: `${API_BASE_URL1}MasterDetails/GetAllotedVehicleDetails?corporationId=${corporationId}&ownerTypeId=${ownerTypeId}&shiftId=${shiftId}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({
        allocatedVehiclesByParams: res || {},
        isFetchingAllocatedByParams: false,
      });
      return res;
    } catch (error) {
      console.error("Error fetching allocated vehicles by params:", error);
      set({ isFetchingAllocatedByParams: false });
      throw error;
    }
  },

  // Save allocated vehicle details
  isAllocatedVehicleLoading: false,

  saveAllocatedVehicleDetails: async (AllocatedData) => {
    console.log("Payload for saving allocated vehicle details:", AllocatedData);
    set({ isAllocatedVehicleLoading: true });
    try {
      const res = await apiCall({
        url: `${API_BASE_URL3}MasterCreate/AddAllotedVehicleDetails`,
        method: "post",
        data: AllocatedData,
        token: localStorage.getItem("token"),
        contentType: "application/json",
      });
      set({ isAllocatedVehicleLoading: false });
      get().fetchAllocatedVehicles();
      return { status: "success", data: res };
    } catch (error) {
      set({ isAllocatedVehicleLoading: false });
      throw error;
    }
  },
}));
